module.exports = __webpack_public_path__ + "media/images/front/sp/institution-treatment-information/img_doctor01-a1d802f57a404e73cddb9b0f2f13096a.jpg";